import { memo } from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell, Typography } from "@mui/material";

import { StatusChip, ButtonV1 } from "components";
import { formatDateTime, formatCount } from "utils";

import { REQUEST_STATUS_CHIP_CONFIG } from "../constants";
import UploadNameTag from "./UploadNameTag";

const StatusHistoryTableRow = ({ request, onViewDetails }) => {
  const statusConfig = REQUEST_STATUS_CHIP_CONFIG[request.status];

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" fontWeight={600}>
          {request.requestId}
        </Typography>
      </TableCell>
      <TableCell>
        <UploadNameTag uploadName={request.uploadName} />
      </TableCell>
      <TableCell>{request.fileName}</TableCell>
      <TableCell>{request.uploadedBy}</TableCell>
      <TableCell>{formatDateTime(request.uploadedAt)}</TableCell>
      <TableCell>
        {statusConfig && (
          <StatusChip
            type={statusConfig.type}
            label={statusConfig.label.toUpperCase()}
          />
        )}
      </TableCell>
      <TableCell>{formatCount(request.totalRows)}</TableCell>
      <TableCell>
        <Typography variant="body2" color="success.dark" fontWeight={600}>
          {formatCount(request.passedRows)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography
          variant="body2"
          color={request.failedRows ? "error.dark" : "text.secondary"}
          fontWeight={600}
        >
          {formatCount(request.failedRows)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" fontWeight={600}>
          {formatCount(request.skippedRows)}
        </Typography>
      </TableCell>

      <TableCell align="right">
        <ButtonV1
          title="Details"
          variant="contained"
          size="small"
          onClick={() => onViewDetails(request)}
        />
      </TableCell>
    </TableRow>
  );
};

StatusHistoryTableRow.propTypes = {
  request: PropTypes.shape({
    requestId: PropTypes.string.isRequired,
    uploadName: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    uploadedBy: PropTypes.string.isRequired,
    uploadedAt: PropTypes.string.isRequired,
    totalRows: PropTypes.number,
    passedRows: PropTypes.number,
    failedRows: PropTypes.number,
    status: PropTypes.string.isRequired,
  }).isRequired,
  onViewDetails: PropTypes.func.isRequired,
};

export default memo(StatusHistoryTableRow);
